module.exports = __webpack_public_path__ + "static/media/redesign-improvement-desktop.0697a900.svg";